import React from 'react'
import { Form, Col } from 'react-bootstrap'
import { connect } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { getLocaleFormLabelKey } from '../../utils/helpers'

const propTypes = {
  fieldConfig: PropTypes.object.isRequired
}

/**
 * Render province component. Note this is used for both states and provinces.
 *
 * @param {object} props with formik, fieldConfig
 * @returns {React.Component} for taking in state or province
 */
const AddressAdminAreaControl = ({
  formik,
  fieldConfig,
  canEdit,
  alignCenter = true,
  columnSize = 5
}) => {
  let provinces = []

  for (const x in fieldConfig.options) {
    provinces.push(fieldConfig.options[x])
  }

  const { t } = useTranslation('common')
  let localizedFormLabel = ''
  if (fieldConfig?.label) {
    localizedFormLabel = t(getLocaleFormLabelKey(fieldConfig.label))
  }

  const selectOption = `- ${t('Select')} -`
  const noneOption = `- ${t('None')} -`

  return (
    <Form.Group
      as={Col}
      md={columnSize}
      controlId="formProvince"
      className={alignCenter ? 'mx-auto' : ''}
    >
      <Form.Label>
        {localizedFormLabel}
        {!fieldConfig?.required ? <span className="form-optional">({t('Optional')})</span> : null}
      </Form.Label>
      {
        // fieldConfig.options being defined means that it is an object keyed by code.
        !formik.values.province?.length ||
        fieldConfig.options?.[formik.values.province] ||
        provinces.includes(formik.values.province) ? (
          <Form.Control
            as="select"
            type="select"
            value={fieldConfig.options?.[formik.values.province] || formik.values.province}
            name="province"
            className="custom-select"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={
              !!formik.errors.province ||
              (fieldConfig.required && !formik.values.province && formik.touched.province)
            }
            disabled={!canEdit}
            required={fieldConfig.required}
          >
            <option value="" defaultValue>
              {fieldConfig.required ? selectOption : noneOption}
            </option>

            {fieldConfig.options &&
              Object.keys(fieldConfig.options).map((code) => (
                <option value={fieldConfig.options[code]} key={code}>
                  {fieldConfig.options[code]}
                </option>
              ))}
          </Form.Control>
        ) : (
          <Form.Control
            type="text"
            name="province"
            value={formik.values.province}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder=""
            isInvalid={!!formik.errors.province}
            maxLength={80}
            readOnly={!canEdit}
            required={fieldConfig.required}
          />
        )
      }
      <Form.Control.Feedback type="invalid">{t('Required')}</Form.Control.Feedback>
    </Form.Group>
  )
}

AddressAdminAreaControl.propTypes = propTypes

export default connect(AddressAdminAreaControl)
